import { Card } from "@mui/material";
import { API_RESPONSE, BANKING_INFORMATION, I18_TRANSLATION_COMMON, NUMBER_CONSTANTS, ROUTES, STORAGE_KEYS, TOASTER_CONFIGS, VALIDATION_CONSTANT } from "../../../../Utilities/Constants/Constants";
import "./BankingInformation.scss";
import * as yup from "yup";
import { Field, Formik } from "formik";
import { RefObject, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { REGEX, REGISTRATION_ERRORS } from "../../../../Utilities/Constants/Validations";
import { GetSessionStorageData } from "../../../../Services/Helpers/Helper";
import API_END_POINTS from "../../../../Utilities/Constants/ApiEndpoints";
import { axiosInstance } from "../../../../Services/Interceptor/Interceptor";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";

const BankingInformation = (props: any) => {
    const { t } = useTranslation(I18_TRANSLATION_COMMON.COMMON);
    const [userType, setuserType]: any = useState("");
    const bankingContainerRef: any = useRef(API_RESPONSE.NULL);
    const [initialValue, setInitialValue] = useState({
        [BANKING_INFORMATION.BANK_NAME]: "",
        [BANKING_INFORMATION.BANK_BRANCH_NAME]: "",
        [BANKING_INFORMATION.ACCOUNT_HOLDER_NAME]: "",
        [BANKING_INFORMATION.ACCOUNT_NUMBER]: "",
        [BANKING_INFORMATION.SWIFT_CODE]: "",
        [BANKING_INFORMATION.IBAN]: "",
    });
    const location = useLocation();
    const bankingValidationScema = yup.object({
        [BANKING_INFORMATION.BANK_NAME]: yup.string().required(REGISTRATION_ERRORS.BANK_NAME),
        [BANKING_INFORMATION.BANK_BRANCH_NAME]: yup.string().required(REGISTRATION_ERRORS.BANK_BRANCH_NAME),
        [BANKING_INFORMATION.ACCOUNT_HOLDER_NAME]: yup.string().required(REGISTRATION_ERRORS.ACCOUNT_HOLDER_NAME),
        [BANKING_INFORMATION.ACCOUNT_NUMBER]: yup.string().required(REGISTRATION_ERRORS.ACCOUNT_NUMBER),
        [BANKING_INFORMATION.SWIFT_CODE]: yup.string().required(REGISTRATION_ERRORS.SWIFT_CODE),
        [BANKING_INFORMATION.IBAN]: yup.string()
        // .matches(REGEX.IBAN_VALIDATION, REGISTRATION_ERRORS.IBAN_VALIDATION)
        .required(REGISTRATION_ERRORS.IBAN_ERROR),
    });
    const [editable, setEditable] = useState(API_RESPONSE.TRUE);

    /* Setting user type */
    useEffect(() => {
        setuserType(GetSessionStorageData(STORAGE_KEYS.ROLE));
    }, []);

    useEffect(() => {
        if (userType == `${NUMBER_CONSTANTS.FIVE}`) {
            getRegistrationDetail(API_END_POINTS.GET_CAMP_DETAILS)
        } else if (userType == `${NUMBER_CONSTANTS.NINE}`) {
            getRegistrationDetail(API_END_POINTS.GET_PERSONAL_DETAILS)
        } else if (userType == `${NUMBER_CONSTANTS.FOUR}`) {
            getRegistrationDetail(API_END_POINTS.GET_SPDETAILS);
        }
    }, [userType]);

    const getRegistrationDetail = (END_POINT: any) => {
        axiosInstance.get(END_POINT).then((response) => {
            if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
                setValues(response.data.result.data[NUMBER_CONSTANTS.ZERO])
            }
        })
    };


    const setValues = (data: any) => {
         setEditable((prev)=>data?.status==="approved" ? API_RESPONSE.FALSE : API_RESPONSE.TRUE);
        setInitialValue({
            [BANKING_INFORMATION.BANK_NAME]: data[BANKING_INFORMATION.BANK_NAME],
            [BANKING_INFORMATION.BANK_BRANCH_NAME]: data[BANKING_INFORMATION.BANK_BRANCH_NAME],
            [BANKING_INFORMATION.ACCOUNT_HOLDER_NAME]: data[BANKING_INFORMATION.ACCOUNT_HOLDER_NAME],
            [BANKING_INFORMATION.ACCOUNT_NUMBER]: data[BANKING_INFORMATION.ACCOUNT_NUMBER],
            [BANKING_INFORMATION.SWIFT_CODE]: data[BANKING_INFORMATION.SWIFT_CODE],
            [BANKING_INFORMATION.IBAN]: data[BANKING_INFORMATION.IBAN],
        })

    }


    /* Navigate call */
    const onNavigate = (state: any) => {
        props.activeStatus(state);
    };

    /* Banking information API call */
    const onSubmitData = (API: any, payload: any) => {
        axiosInstance.put(API + `?${VALIDATION_CONSTANT.PAGE}=` + NUMBER_CONSTANTS.FOUR, payload).then((response: any) => {
            if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
                toast.success(response.data.message, TOASTER_CONFIGS);
                if (location.pathname !== ROUTES.PROFILE)
                    onNavigate(NUMBER_CONSTANTS.FIVE)
            }
        })
    };

    /* Defining API based on type of users */
    const onSubmitInformation = (payload: any) => {
        if (userType === `${NUMBER_CONSTANTS.FIVE}`) {
            onSubmitData(location.pathname === ROUTES.PROFILE ? API_END_POINTS.CAMP_PROFILE_UPDATE : API_END_POINTS.CAMP_PROFESSIONAL_REGISTER, payload)
        } else if (userType === `${NUMBER_CONSTANTS.NINE}`) {
            onSubmitData(location.pathname === ROUTES.PROFILE ? API_END_POINTS.TRAINER_PROFILE_UPDATE : API_END_POINTS.PERSONAL_PROFESSIONAL_REGISTER, payload)
        } else if (userType === `${NUMBER_CONSTANTS.FOUR}`) {
            onSubmitData(location.pathname === ROUTES.PROFILE ? API_END_POINTS.TUTOR_PROFILE_UPDATE : API_END_POINTS.TUTOR_VERIFY, payload);
        } else if (userType === `${NUMBER_CONSTANTS.THREE}`) {
            onSubmitData(location.pathname === ROUTES.PROFILE ? API_END_POINTS.TUTOR_PROFILE_UPDATE : API_END_POINTS.EXPERTS_REGISTRATION, payload);
        }
    }

    return (
        <div className="row" ref={bankingContainerRef}>
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <Card className="banking-information-wrapper">
                    <Formik
                        validationSchema={bankingValidationScema}
                        initialValues={initialValue}
                        enableReinitialize={true}
                        onSubmit={(values, actions) => {
                            onSubmitInformation(values);
                        }}
                    >
                        {
                            (formik: any) => {
                                return (
                                    <div>
                                        <h4 className="header-title">Banking Information</h4>
                                        <div className="row row-wrap">
                                            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                                <div className="form-items">
                                                    <label className="form-label">{t("Bank name")}</label>
                                                    <Field
                                                        name={BANKING_INFORMATION.BANK_NAME}
                                                        className="email-input"
                                                        placeholder={t("Ex: United Arab Bank")}
                                                        maxLength={50}
                                                        disabled={editable ? false : true}
                                                    />
                                                    <div className="errorMessage">
                                                        {formik.touched[BANKING_INFORMATION.BANK_NAME] &&
                                                            formik.errors[BANKING_INFORMATION.BANK_NAME] && (
                                                                <p>
                                                                    {t(
                                                                        `${formik.errors[BANKING_INFORMATION.BANK_NAME]
                                                                        }`
                                                                    )}
                                                                </p>
                                                            )}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                                <div className="form-items">
                                                    <label className="form-label">{t("Bank branch name")}</label>
                                                    <Field
                                                        name={BANKING_INFORMATION.BANK_BRANCH_NAME}
                                                        className="email-input"
                                                        placeholder={t("Bank branch XXX")}
                                                        maxLength={50}
                                                        disabled={editable ? false : true}
                                                    />
                                                    <div className="errorMessage">
                                                        {formik.touched[BANKING_INFORMATION.BANK_BRANCH_NAME] &&
                                                            formik.errors[BANKING_INFORMATION.BANK_BRANCH_NAME] && (
                                                                <p>
                                                                    {t(
                                                                        `${formik.errors[BANKING_INFORMATION.BANK_BRANCH_NAME]
                                                                        }`
                                                                    )}
                                                                </p>
                                                            )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row row-wrap">
                                            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                                <div className="form-items">
                                                    <label className="form-label">{t("Account holder name")}</label>
                                                    <Field
                                                        name={BANKING_INFORMATION.ACCOUNT_HOLDER_NAME}
                                                        className="email-input"
                                                        placeholder={t("Ex: AbcXX")}
                                                        maxLength={50}
                                                        disabled={editable ? false : true}
                                                    />
                                                    <div className="errorMessage">
                                                        {formik.touched[BANKING_INFORMATION.ACCOUNT_HOLDER_NAME] &&
                                                            formik.errors[BANKING_INFORMATION.ACCOUNT_HOLDER_NAME] && (
                                                                <p>
                                                                    {t(
                                                                        `${formik.errors[BANKING_INFORMATION.ACCOUNT_HOLDER_NAME]
                                                                        }`
                                                                    )}
                                                                </p>
                                                            )}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                                <div className="form-items">
                                                    <label className="form-label">{t("Account Number")}</label>
                                                    <Field
                                                        name={BANKING_INFORMATION.ACCOUNT_NUMBER}
                                                        className="email-input"
                                                        placeholder={t("Ex: 1234567890123456")}
                                                        maxLength={50}
                                                        disabled={editable ? false : true}
                                                    />
                                                    <div className="errorMessage">
                                                        {formik.touched[BANKING_INFORMATION.ACCOUNT_NUMBER] &&
                                                            formik.errors[BANKING_INFORMATION.ACCOUNT_NUMBER] && (
                                                                <p>
                                                                    {t(
                                                                        `${formik.errors[BANKING_INFORMATION.ACCOUNT_NUMBER]
                                                                        }`
                                                                    )}
                                                                </p>
                                                            )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row row-wrap">
                                            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                                <label className="form-label">{t("SWIFT Code")}</label>
                                                <Field
                                                    name={BANKING_INFORMATION.SWIFT_CODE}
                                                    className="email-input"
                                                    placeholder={t("Ex: ARABJOAX100")}
                                                    maxLength={50}
                                                    disabled={editable ? false : true}
                                                />
                                                <div className="errorMessage">
                                                    {formik.touched[BANKING_INFORMATION.SWIFT_CODE] &&
                                                        formik.errors[BANKING_INFORMATION.SWIFT_CODE] && (
                                                            <p>
                                                                {t(
                                                                    `${formik.errors[BANKING_INFORMATION.SWIFT_CODE]
                                                                    }`
                                                                )}
                                                            </p>
                                                        )}
                                                </div>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                                <label className="form-label">{t("IBAN Number")}</label>
                                                <Field
                                                    name={BANKING_INFORMATION.IBAN}
                                                    className="email-input"
                                                    placeholder={t("Ex: AE070331234567890123456")}
                                                    disabled={editable ? false : true}
                                                />
                                                <div className="errorMessage">
                                                    {formik.touched[BANKING_INFORMATION.IBAN] &&
                                                        formik.errors[BANKING_INFORMATION.IBAN] && (
                                                            <p>
                                                                {t(
                                                                    `${formik.errors[BANKING_INFORMATION.IBAN]
                                                                    }`
                                                                )}
                                                            </p>
                                                        )}
                                                </div>
                                            </div>
                                        </div>

                                        {
                                            location.pathname === ROUTES.PROFILE
                                                ?
                                                <div className="banking-buttons-wrap">
                                                    {/*  <button
                                                className="btn btn-back"
                                                onClick={() => {
                                                    if (bankingContainerRef.current) {
                                                        bankingContainerRef.current.scrollTop = 0;
                                                      }
                                                    }}
                                                >
                                                Reset
                                                </button> */}
                                                   {editable && <button
                                                        className="btn btn-next"
                                                        type="submit"
                                                        onClick={() => {
                                                            formik.handleSubmit()
                                                        }}
                                                    >
                                                        Update
                                                    </button>}
                                                </div>
                                                :
                                                <div className="banking-buttons-wrap">
                                                    <button
                                                        className="btn btn-back"
                                                        onClick={() => onNavigate(NUMBER_CONSTANTS.THREE)}
                                                    >
                                                        Back
                                                    </button>
                                                    <button
                                                        className="btn btn-next"
                                                        type="submit"
                                                        onClick={() => {
                                                            formik.handleSubmit()
                                                        }}
                                                    >
                                                        Next
                                                    </button>
                                                </div>
                                        }


                                    </div>
                                )
                            }
                        }
                    </Formik>
                </Card>
            </div>
        </div>
    )
};

export default BankingInformation;